import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

/**
 * Cookie consent banner component
 * Displays a minimalistic GDPR-compliant notice about necessary cookies
 * Stores dismissal in localStorage to avoid showing again
 */
const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  // Check localStorage on mount
  useEffect(() => {
    const hasConsented = localStorage.getItem('cookieConsent') === 'accepted';
    if (!hasConsented) {
      // Small delay to allow page to render first
      const timer = setTimeout(() => setIsVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setIsAnimatingOut(true);
    // Wait for animation to complete before hiding
    setTimeout(() => {
      localStorage.setItem('cookieConsent', 'accepted');
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div
      role="region"
      aria-label="Informacja o plikach cookie"
      className={`fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-input-border shadow-lg ${
        isAnimatingOut ? 'cookie-banner-exit' : 'cookie-banner-enter'
      }`}
    >
      <div className="container mx-auto px-4 py-4 sm:py-5">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm sm:text-base text-text-secondary flex-1">
            Ta strona używa niezbędnych plików cookie do prawidłowego działania (zabezpieczenie
            formularzy). Korzystając ze strony, akceptujesz ich użycie.{' '}
            <Link
              to="/polityka-prywatnosci"
              className="text-primary underline hover:text-primary-dark transition-colors"
            >
              Polityka prywatności
            </Link>
          </p>
          <Button variant="primary" size="sm" onClick={handleAccept} className="shrink-0">
            Rozumiem
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;


